export default __webpack_public_path__ + "static/media/interstate-mob.9673484d.png";